import { render, staticRenderFns } from "./cart_order.vue?vue&type=template&id=560b5ce3&scoped=true"
import script from "./cart_order.vue?vue&type=script&lang=js"
export * from "./cart_order.vue?vue&type=script&lang=js"
import style0 from "./cart_order.vue?vue&type=style&index=0&id=560b5ce3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560b5ce3",
  null
  
)

export default component.exports